window.$ = window.jQuery = require("jquery");
import "bootstrap";
import "./componentes/busca.js";
import "./componentes/conteudos.js";
import "./componentes/downloads.js";
import "./componentes/flavor.js";
import "./componentes/flavorsCarousel.js";
import "./componentes/forms/contato.js";
import "./componentes/formularios.js";
import "./componentes/heroHome.js";
import "./componentes/productCarousel.js";
import "./componentes/produto-single.js";
import "./componentes/produto.js";
import "./componentes/sobre.js";
import "./componentes/tab.js";
import { initCalculadoraForm } from "./componentes/calculadora-form.js";
// import "./componentes/vitrine.js";
// import "./contato/onde-encontrar.js";
// import "./produtos/carrinho.js";
// import "./produtos/ponteiras.js";
// import "./produtos/silenciosos.js";

window.addEventListener("load", function (event) {
    const { menu, menuMobile } = require("./parts/menu.js");
    menuMobile();
    if (screen.width < 769) {
        menu();
    }

    initCalculadoraForm();

    // header();
    // sliderModelos();
});

// document.addEventListener("DOMContentLoaded", function () {
//     if (
//         sessionStorage.getItem("userLogged") === null ||
//         sessionStorage.getItem("userLogged") === "false"
//     ) {
//         fetch("/me")
//             .then((response) => response.json())
//             .then((data) => {
//                 if (data.status) {
//                     sessionStorage.setItem("userLogged", true);
//                 } else {
//                     sessionStorage.setItem("userLogged", false);
//                     $(".login-button").text("Entrar");
//                 }
//             })
//             .catch((error) => {
//                 console.error("Error:", error);
//                 sessionStorage.setItem("userLogged", false);
//                 $(".login-button").text("Entrar");
//             });
//     } else {
//         $(".login-button").text("Sair");
//     }
// });
